import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { BuildingIcon } from './ui/Icons';

const Footer = () => {
  const { theme } = useTheme();
  
  return (
    <footer className={`${theme.colors.surface} ${theme.border.light} border-t py-6 px-8`}>
      <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className={`p-2 ${theme.colors.primary} ${theme.text.inverse} rounded-lg ${theme.shadow.sm}`}>
              <BuildingIcon className="w-4 h-4" />
            </div>
            <div>
              <div className={`text-sm font-medium ${theme.text.primary}`}>
                © 2024 Unibyte
              </div>
              <div className={`text-xs ${theme.text.muted}`}>
                Quality Management System
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-6">
          <a href="#" className={`text-sm ${theme.text.secondary} hover:${theme.text.primary} transition-colors font-medium hover:underline`}>
            Privacy Policy
          </a>
          <a href="#" className={`text-sm ${theme.text.secondary} hover:${theme.text.primary} transition-colors font-medium hover:underline`}>
            Terms of Service
          </a>
          <a href="#" className={`text-sm ${theme.text.secondary} hover:${theme.text.primary} transition-colors font-medium hover:underline`}>
            Support
          </a>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className={`px-3 py-1 ${theme.colors.background} rounded-lg ${theme.border.light} border`}>
            <span className={`text-xs font-medium ${theme.text.secondary}`}>Version 2.0.0</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            <span className={`text-xs ${theme.text.secondary} font-medium`}>All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;